<template>
  <BadgeTag
    v-if="statusValue"
    :icon="compact ? 'fa-solid fa-circle fa-2xs' : 'fa-solid fa-circle fa-xs'"
    :label="compact ? '' : displayLabel"
    :color="resolvedColor"
    :tooltip="resolvedTooltip"
    :class="{ 'is-compact': compact }"
  />
</template>

<script>
import { computed } from 'vue'
import { capitalizeWords as capitalize, rmUnderscores } from '@/filters/filters'
import {
  ARCHIVE_STATUS_COLOR_MAP,
  ASSAY_STATE_STATUS_COLOR_MAP,
  SAMPLE_STATE_STATUS_COLOR_MAP,
  COLLECTION_STATUS_COLOR_MAP,
  DATA_STATUS_COLOR_MAP,
  EXPERIMENT_STATUS_COLOR_MAP,
  ORDEREDITEM_STATUS_COLOR_MAP,
  VOCABULARY_STATUS_COLOR_MAP,
} from '@/constants'

const STATUS_COLOR_MAP = {
  ...ARCHIVE_STATUS_COLOR_MAP,
  ...ASSAY_STATE_STATUS_COLOR_MAP,
  ...SAMPLE_STATE_STATUS_COLOR_MAP,
  ...COLLECTION_STATUS_COLOR_MAP,
  ...DATA_STATUS_COLOR_MAP,
  ...EXPERIMENT_STATUS_COLOR_MAP,
  ...ORDEREDITEM_STATUS_COLOR_MAP,
  ...VOCABULARY_STATUS_COLOR_MAP,
}

const STATUS_MESSAGE_MAP = {
  error: 'One or more datafile copies are in error state.',
}

export default {
  name: 'StatusWidget',
  props: {
    compact: { type: Boolean, default: false },
    fieldMeta: { type: Object, default: null },
    status: { type: Object },
    statusColor: { type: String },
    tooltipText: { type: String },
  },
  setup(props) {
    const labelField = props.fieldMeta?.choices?.label_field || 'label'
    const valueField = props.fieldMeta?.choices?.value_field || 'value'

    const statusValue = computed(() =>
      (props.status?.[valueField] || '').toLowerCase(),
    )
    const statusLabel = computed(() =>
      (props.status?.[labelField] || '').toLowerCase(),
    )
    const resolvedColor = computed(
      () =>
        props.statusColor ?? STATUS_COLOR_MAP[statusValue.value] ?? 'primary',
    )
    const displayLabel = computed(() =>
      capitalize(statusLabel.value || statusValue.value),
    )
    const resolvedTooltip = computed(
      () =>
        props.tooltipText ||
        STATUS_MESSAGE_MAP[statusValue.value] ||
        capitalize(rmUnderscores(statusLabel.value || statusValue.value)),
    )

    return { displayLabel, resolvedColor, resolvedTooltip, statusValue }
  },
}
</script>

<style lang="scss" scoped>
.is-compact {
  :deep(.tag) {
    height: 1.5em;
    font-size: var(--bulma-size-small);
  }
}
</style>
